import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicePackages from "./sections/ServicePackages";
import TheProcess from "./sections/TheProcess";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicePackages />
      <TheProcess />
      <CommonInquiries />
      <Footer />
    </div>;
}